import React, { useState } from 'react';
import InputMask from "react-input-mask";
import { MdOutlineClose } from "react-icons/md";
import { FiPlus } from "react-icons/fi";
import { useSelector } from 'react-redux';


const EditModal = ({ stateOptions, isOpen, onClose, editData, setEditData, handleOnChange, handleEditSubmit, error, adminListForCust }) => {
  const [remarks, setRemarks] = useState([{ id: 1, text: "" }]);
  const adminData = useSelector((state) => state.users.adminData);
  const adminType = adminData?.admin_type || "";

  const handleOnRemarkChange = (id, text) => {
    setRemarks((prev) => {
      const updatedRemark = prev.map((remark) => (remark.id === id ? { ...remark, text } : remark));

      const validRemarks = updatedRemark.filter(r => String(r?.text).length !== 0);
      setEditData((prevEditData) => ({
        ...prevEditData,
        remark: validRemarks,
      }));
      return updatedRemark;
    });
  };


  const handleAddRemark = () => {
    setRemarks((prev) => [...prev, { id: prev.length + 1, text: "" }]);
  };

  const handleRemoveRemark = (id) => {
    setRemarks((prev) => prev.filter((remark) => remark.id !== id));
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-[1000px] h-[67vh] overflow-hidden overflow-y-auto p-6">

        <div className="flex justify-between items-center mb-4 border-b pb-3">
          <h2 className="text-xl font-semibold text-gray-800">Add New Customer  </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-red-500">
            <MdOutlineClose className='w-9 h-9 bg-gray-100 rounded-full p-1' />
          </button>
        </div>


        <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3'>

          <div className="">
            <label htmlFor="name" className="block text-sm font-medium text-black">
              First Name *
            </label>
            <input
              type="text"
              id="name"
              name='f_name'
              value={editData?.f_name || null}
              onChange={handleOnChange}
              placeholder="First Name"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.f_name && <span className='text-sm text-red-500'>{error.f_name}</span>}
          </div>

          <div className="">
            <label htmlFor="l_name" className="block text-sm font-medium text-black">
              Last Name *
            </label>
            <input
              type="text"
              id="l_name"
              name='l_name'
              value={editData?.l_name || null}
              onChange={handleOnChange}
              placeholder="Last name"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.l_name && <span className='text-sm text-red-500'>{error.l_name}</span>}
          </div>

          <div className="">
            <label htmlFor="license_key" className="block text-sm font-medium text-black">
              License Key *
            </label>
            <InputMask
              mask="9999-9999-9999-9999"
              placeholder="0000-0000-0000-0000"
              value={editData?.license_key || 0}
              disabled={true}
            >
              {(inputProps) => (
                <input
                  {...inputProps}
                  id="license_key"
                  type="text"
                  name='license_key'
                  className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
                />
              )}
            </InputMask>
          </div>


          <div className="">
            <label htmlFor="weighbridge_id" className="block text-sm font-medium text-black">
              WeighBridge ID *
            </label>
            <input
              type="text"
              id="weighbridge_id"
              name='weighbridge_id'
              value={editData?.weighbridge_id || null}
              onChange={handleOnChange}
              placeholder="Enter WeighBridge ID"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.weighbridge_id && <span className='text-sm text-red-500'>{error.weighbridge_id}</span>}
          </div>

          <div className="">
            <label htmlFor="date_of_birth" className="block text-sm font-medium text-black">
              Date Of Installation *
            </label>
            <input
              type="date"
              id="date_of_birth"
              name='date_of_birth'
              placeholder="Choose Date"
              value={editData?.date_of_birth || null}
              onChange={handleOnChange}
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
          </div>


          <div className="">
            <label htmlFor="mac_address" className="block text-sm font-medium text-black">
              IP Address (System's) *
            </label>
            <input
              type="text"
              id="mac_address"
              name='mac_address'
              value={editData?.mac_address || null}
              onChange={handleOnChange}
              placeholder="MAC Address"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
          </div>

          <div className="">
            <label htmlFor="expired_on" className="block text-sm font-medium text-black">
              Expiry Date *
            </label>
            <input
              type="date"
              id="expired_on"
              placeholder="Expiry Date"
              name='expired_on'
              value={editData?.expired_on || null}
              onChange={handleOnChange}
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
          </div>


          <div className="">
            <label htmlFor="address" className="block text-sm font-medium text-black">
              Address
            </label>
            <input
              type="text"
              id="address"
              name='address'
              value={editData?.address || null}
              onChange={handleOnChange}
              placeholder="Address"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
          </div>

          <div className="">
            <label htmlFor="city" className="block text-sm font-medium text-black">
              City *
            </label>
            <input
              type="text"
              id="city"
              placeholder="City"
              name='city'
              value={editData?.city || null}
              onChange={handleOnChange}
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.city && <span className='text-sm text-red-500'>{error.city}</span>}
          </div>

          <div className="">
            <label htmlFor="state" className="block text-sm font-medium text-black">
              State *
            </label>
            <select
              id="state"
              name='state'
              value={editData?.state || null}
              onChange={handleOnChange}
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm">
              <option value={""}>State</option>
              {stateOptions.map(state => <option value={state}>{state}</option>)}
            </select>
            {error?.state && <span className='text-sm text-red-500'>{error.state}</span>}
          </div>

          <div className="">
            <label htmlFor="email" className="block text-sm font-medium text-black">
              Email
            </label>
            <input
              type="email"
              id="email"
              name='email'
              value={editData?.email || null}
              onChange={handleOnChange}
              placeholder="Email"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
          </div>

          <div className="">
            <label htmlFor="phone" className="block text-sm font-medium text-black">
              Phone Number *
            </label>
            <input
              type="text"
              id="phone"
              name='phone'
              value={editData?.phone || null}
              onChange={handleOnChange}
              placeholder="Phone"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.phone && <span className='text-sm text-red-500'>{error.phone}</span>}
          </div>


          <div className="">
            <label htmlFor="referred_by_name" className="block text-sm font-medium text-black">
              Referral Name
            </label>
            <input
              type="text"
              id="referred_by_name"
              name='referred_by_name'
              value={editData?.referred_by_name || null}
              onChange={handleOnChange}
              placeholder="Referral Name"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.referred_by_name && <span className='text-sm text-red-500'>{error.referred_by_name}</span>}
          </div>

          <div className="">
            <label htmlFor="referred_by_phone" className="block text-sm font-medium text-black">
              Referral Phone Number
            </label>
            <input
              type="text"
              id="referred_by_phone"
              name='referred_by_phone'
              value={editData?.referred_by_phone || null}
              onChange={handleOnChange}
              placeholder="Referral Phone"
              className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm"
            />
            {error?.referred_by_phone && <span className='text-sm text-red-500'>{error.referred_by_phone}</span>}
          </div>
          {adminType && adminType != "sub_admin" && <div className="">
            <label htmlFor="assign_admin_id" className="block text-sm font-medium text-black">
              Assign To Admin
            </label>
            <select id="assign_admin_id"
              name='assign_admin_id' value={editData?.assign_admin_id || null}
              onChange={handleOnChange} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm">
              {/* Need to add it for default selected candidate*/}
              <option value={null} >{"Select Admin"}</option>
              {adminListForCust?.map((e, i) => <option key={i} value={e.id}>{e.user_name}</option>)}
            </select>
          </div>}
        </div>
        <div>
          <div className='flex items-center justify-between'>
            <p className="block text-sm font-medium text-black">Remarks</p>
            <button type="button" onClick={handleAddRemark} className="flex items-center justify-end space-x-2 px-4 py-2 text-white bg-green-500 font-semibold rounded-md text-sm">
              <span><FiPlus className='w-5 h-5' /></span>
              <span className='uppercase'>Add remark</span>
            </button>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
            {remarks.map((remark, index) => (
              <div>
                <input type="remark" id="remark" name='remark' value={remark?.text || null} onChange={(e) => handleOnRemarkChange(remark.id, e.target.value)} placeholder="Remark" className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
                <button type="button" onClick={() => handleRemoveRemark(remark.id)} className="mt-2 text-red-500 hover:text-red-700 text-sm">Remove</button>
              </div>))}
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <button className={`px-4 py-1.5 text-lg font-medium text-white bgbtn rounded-md transition md:w-64 w-full disable`} onClick={handleEditSubmit}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditModal;
